import { configureStore } from '@reduxjs/toolkit';
import todoReducer from './libs/todoSlice';
import sideBarSlice from './libs/sideBarSlice';
import manageMemberSlice from './libs/manageMemberSlice';
import loginUserSlice from './libs/LoginUserSlice'
import changePasswordSlice from './libs/changePasswordSlice'
import sendMailSlice from './libs/sendMailSlice'
import verifyDetailSlice from './libs/verifyDetailSlice'
import createPathSlice from './libs/createPathSlice'
import loginSlice from './libs/loginSlice'
import sendMailSuccessSlice from './libs/sendMailSuccessSlice'
import termAndConditionSlice from './libs/termAndConditionSlice'
import addFailSlice from './libs/addFailSlice';
import digitalWorkFlowSlice from './libs/digitalWorkFlowSlice';
import mainSlice from './libs/mainSlice';
import themeColorSlice from './libs/themeColorSlice';
import themeSlice from './libs/themeSlice';
import historySlice from './libs/historySlice';
import eduPortalManagementSlice from './libs/eduPortalManagementSlice';
import tableSlice from './libs/tableSlice';
import profileSlice from './libs/profileSlice';
import preregisSlice from './libs/preregisSlice';


export default configureStore({
  reducer: {
    todos: todoReducer,
    sidebar: sideBarSlice,
    manageMember: manageMemberSlice,
    loginUser:loginUserSlice,
    changePassword:changePasswordSlice,
    sendMail:sendMailSlice,
    verifyDetail:verifyDetailSlice,
    createPath:createPathSlice,
    login:loginSlice,
    sendMailSuccess:sendMailSuccessSlice,
    termAndCondition:termAndConditionSlice,
    addFail:addFailSlice,
    digitalWorkFlow:digitalWorkFlowSlice,
    main:mainSlice,
    themeColor:themeColorSlice,
    theme:themeSlice,
    history:historySlice,
    eduPortalManagement: eduPortalManagementSlice,
    tableEdu:tableSlice,
    profile: profileSlice,
    preRegis:preregisSlice
  },
  devTools: process.env.REACT_APP_ENV === 'local'
});